import { CategoryComponents } from "./category";
import { DepartmentComponents } from "./department";
import { DepartmentGroupComponents } from "./department-group";
import { LayoutComponents } from "./layout";
import { ProgramComponents } from "./program";
import { ProjectComponents } from "./project";
import { PropertyComponents } from "./property";
import { RoomComponents } from "./room";
import { RoomContentComponents } from "./room-content";
import { RoomGroupComponents } from "./room-group";

export * from "./room";
export * from "./department";
export * from "./project";
export * from "./program";
export * from "./category";
export * from "./room-content";
export * from "./department-group";
export * from "./room-group";
export * from "./layout";
export * from "./property";

export const CatalogComponents = [
    ...RoomComponents,
    ...DepartmentComponents,
    ...ProjectComponents,
    ...ProgramComponents,
    ...CategoryComponents,
    ...RoomContentComponents,
    ...DepartmentGroupComponents,
    ...RoomGroupComponents,
    ...LayoutComponents,
    ...PropertyComponents
]; 